// extracted by mini-css-extract-plugin
export default {"button":"styles_button__POqhI","modal":"styles_modal__R04kd"};